import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import Nosotros from "@/components/site/Nosotros";
import Catalogo from "@/components/site/Catalogo";
import Servicios from "@/components/site/Servicios";
import Footer from "@/components/site/Footer";
import StickyCTA from "@/components/site/StickyCTA";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="bg-[#04070D] text-white min-h-screen">
      <div className="noise-overlay" />
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Nosotros />
        <Catalogo />
        <Servicios />
      </main>
      <Footer />
      <StickyCTA />
    </div>
  );
}

export default App;
